// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vfBq","title":"styles_title__THjuR"};